export const getFundsVerificationSubject = totalDown => {
  return `Confirm your ${totalDown} payment`;
};

export const getFundsVerificationMessage = (totalDown, accountNumberMask) => {
  return `We need to confirm ${totalDown} is in your bank account ending in #${accountNumberMask}.\n \nSave time by securely linking your bank account. Or, you can give us a call to confirm your ${totalDown} payment over a three-way call, with Carvana and your bank, at 1 (800) 333-4554(open daily between 8am and 9pm EST).`;
};
